/**
 * Enum pour ModeSAML
 */
export enum ModeSAML {
    SP = 'SP',
    IDP = 'IDP',
}

/**
 * Configuration du SAML
 */
export interface SamlConfiguration {
    /** Id technique */
    idConfig: number;

    /** Default claim */
    defaultClaim?: string;

    /** URL des metadata de l'IdP (si pas de fichier) */
    idpUrl?: string;

    /** Indicateur de présence du fichier idp */
    hasIdpFile?: boolean;

    /** Mode de connexion SAML */
    mode?: ModeSAML;

    /** Certificat SP */
    spCertificate?: string;

    /** Clef privée SP */
    spPrivateKey?: string;

    /** Indicateur de présence du fichier clef privée */
    hasSpPrivateKey?: boolean;

    /** Chiffrement des échanges */
    encryptNameId?: boolean;

    /** URI du contexte d'authentification */
    authContext?: string;

    /** Identifiant de l'utilisateur ayant effectué la dernière modification */
    idUserModification?: number;

    /** Date de la dernière modification de la configuration */
    dateModification?: Date;
}
